//STYLE************************************************
import '../css/app.scss';

//COMPONENTS********************************************
import VideoPlayer from './components/video-player';
